// extracted by mini-css-extract-plugin
export default {"pictureContainer":"EJ_uP7rK3HC2zg14JgWw"};